import type { IconSvgObject } from './types';

const WaterfallUp01Icon: IconSvgObject = [
  ["path", { d: "M3 3V21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 17V14M12 14V9M16 9V6M20 10V4", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default WaterfallUp01Icon;
